<!-- eslint-disable vue/html-closing-bracket-newline -->
<!-- eslint-disable vue/first-attribute-linebreak -->
<!-- eslint-disable vue/max-attributes-per-line -->
<!-- eslint-disable vue/html-indent -->
<template>
    <div class="modal modal-open items-start !animate-none overflow-y-auto">
        <div class="absolute top-0 bottom-0 right-0 left-0" @click.prevent="$emit('close')" />
        <div class="modal-box pt-4 pb-6 px-6 mt-20 max-h-none w-full max-w-xl bg-white">
            <div class="flex justify-between items-center border-b pb-2 mb-2 font-medium">
                <span>
                    {{ field.name || buildDefaultName(field, template.fields) }}
                </span>
                <a href="#" class="text-xl" @click.prevent="$emit('close')">&times;</a>
            </div>
            <div>
                <form @submit.prevent="saveAndClose">
                    <!-- Date field specific UI -->
                    <template v-if="field.type === 'date'">
                        <div class="space-y-1 mb-1">
                            <div>
                                <label dir="auto" class="label text-sm" for="label_field">
                                    {{ t('label') }}
                                </label>
                                <input id="label_field" v-model="title" dir="auto" :readonly="!editable"
                                    class="base-input !text-base w-full" :placeholder="t('effective_date')">
                            </div>
                            <div>
                                <label dir="auto" class="label text-sm items-start flex flex-col" for="date_value_field">
                                    <span>
                                        {{ t('date') }}
                                    </span>
                                    <span class="text-xs text-gray-500">Make sure the selected date matches the intended field label</span>
                                </label>
                                
                                <input id="date_value_field" v-model="description" type="date" :readonly="!editable"
                                    class="base-input !text-base w-full">
                            </div>
                            <div class="pt-2">
                                <label class="cursor-pointer flex items-center space-x-2">
                                    <input v-model="showOnDocument" type="checkbox"
                                        class="toggle toggle-sm [--tglbg:white]" :disabled="!editable">
                                    <span class="label-text">{{ t('show_on_document') }}</span>
                                </label>
                            </div>
                        </div>
                    </template>
                    <!-- Default UI for other field types -->
                    <template v-else>
                        <div class="space-y-1 mb-1">
                            <div>
                                <label dir="auto" class="label text-sm" for="description_field">
                                    {{ t('description') }}
                                </label>
                                <textarea id="description_field" ref="textarea" v-model="description" dir="auto"
                                    class="base-textarea !text-base w-full" :readonly="!editable" @input="resizeTextarea" />
                            </div>
                            <div>
                                <label dir="auto" class="label text-sm" for="title_field">
                                    {{ t('display_title') }} ({{ t('optional') }})
                                </label>
                                <input id="title_field" v-model="title" dir="auto" :readonly="!editable"
                                    class="base-input !text-base w-full">
                            </div>
                        </div>
                    </template>
                    <button class="button-cs-primary w-full mt-4">
                        {{ t('save') }}
                    </button>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'DescriptionModal',
    inject: ['t', 'save', 'template'],
    props: {
        field: {
            type: Object,
            required: true
        },
        editable: {
            type: Boolean,
            required: false,
            default: true
        },
        buildDefaultName: {
            type: Function,
            required: true
        }
    },
    emits: ['close'],
    data() {
        return {
            description: this.field.description,
            title: this.field.title || (this.field.type === 'date' ? 'Effective Date' : ''),
            showOnDocument: this.field.preferences?.show_on_document !== false
        }
    },
    mounted() {
        if (this.field.type !== 'date') {
            this.resizeTextarea()
        }
    },
    methods: {
        saveAndClose() {
            this.field.description = this.description
            this.field.title = this.title

            if (this.field.type === 'date') {
                this.field.preferences ||= {}
                this.field.preferences.show_on_document = this.showOnDocument
            }

            this.save()
            this.$emit('close')
        },
        resizeTextarea() {
            const textarea = this.$refs.textarea

            if (textarea) {
                textarea.style.height = 'auto'
                textarea.style.height = textarea.scrollHeight + 'px'
            }
        }
    }
}
</script>
